export const env = {
  bot: {
    username: import.meta.env.VITE_BOT_USERNAME as string || 'DropeeBot',
    appShortName: 'play',
    shareText: `🎉 Join me on Dropee and start stacking rewards! 🎰
💸 +5k coins and 5 spins just for signing up
💎 +25k coins if you’ve got Telegram Premium
Ready to get your rewards? Let’s play together now! 🚀`,
  },
  api: {
    // baseUrl: 'http://localhost:8787',
    baseUrl: import.meta.env.VITE_API_BASE_URL as string,
  },
  lingo: {
    baseApiUrl: import.meta.env.VITE_LINGO_API_BASE_URL,
  },
  shop: {
    contractAddress: import.meta.env.VITE_SHOP_CONTRACT_ADDRESS as string,
  },
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string,
  gtmId: import.meta.env.VITE_GTM_ID as string,
  app: {
    url: import.meta.env.VITE_URL as string,
    isProd: import.meta.env.VITE_ENV === 'prod',
  },
}
